import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-46793328"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "multi-menu__menu__list__item__icon" }
const _hoisted_2 = { class: "multi-menu__menu__list__item__title" }
const _hoisted_3 = { class: "multi-menu__menu__list__item__description" }

import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import { storeToRefs } from 'pinia';

import { useCommonStore } from '@/store/common';
import { useServicesStore } from '@/store/services';

import AiClearButton from '@/components/UI/AiClearButton/AiClearButton.vue';

import { IMultiMenuItem } from '@/types/IMultiMenuItem';

import { TService } from '@/types/TService';
import { useEditorStore } from '@/store/editor';


export default /*#__PURE__*/_defineComponent({
  __name: 'MultiMenu',
  setup(__props) {

const { t } = useI18n();

const { generateImageData } = storeToRefs(useEditorStore());
const { currentService, isMobile, servicesList } = storeToRefs(useCommonStore());
const { imageResult, imageForActions, sourceBgImage, imagePrev } = storeToRefs(useServicesStore());

const menuOpened = ref<boolean>(false);
const menuList = ref<IMultiMenuItem[]>([
  {
    title: t('multi-menu.market-title'),
    description: t('multi-menu.market-description'),
    color: 'var(--accent-100)',
    // eslint-disable-next-line global-require
    icon: require('@/assets/icons/multi-menu/market.svg'),
    service: 'create_background_for_image',
  },
  {
    title: t('multi-menu.remove-background-title'),
    description: t('multi-menu.remove-background-description'),
    color: '#FF9EEA',
    // eslint-disable-next-line global-require
    icon: require('@/assets/icons/multi-menu/remove-background.svg'),
    service: 'remove_background',
  },
  {
    title: t('multi-menu.infographics-title'),
    description: t('multi-menu.infographics-description'),
    color: '#86A1FF',
    // eslint-disable-next-line global-require
    icon: require('@/assets/icons/multi-menu/infographics.svg'),
    service: 'infographics',
  },
  {
    title: t('multi-menu.upscale-title'),
    description: t('multi-menu.upscale-description'),
    color: '#54FFC1',
    // eslint-disable-next-line global-require
    icon: require('@/assets/icons/multi-menu/upscale.svg'),
    service: 'upscale',
  },
  {
    title: t('multi-menu.outpaint-title'),
    description: t('multi-menu.outpaint-description'),
    color: '#FF9839',
    // eslint-disable-next-line global-require
    icon: require('@/assets/icons/multi-menu/outpaint.svg'),
    service: 'outpaint',
  },
  {
    title: t('multi-menu.inpaint-title'),
    description: t('multi-menu.inpaint-description'),
    color: '#E4E4E4',
    // eslint-disable-next-line global-require
    icon: require('@/assets/icons/multi-menu/inpaint.svg'),
    service: 'inpaint',
  },
  {
    title: t('multi-menu.shadow-title'),
    description: t('multi-menu.shadow-description'),
    color: '#FFF069',
    // eslint-disable-next-line global-require
    icon: require('@/assets/icons/multi-menu/shadow.svg'),
    service: 'shadow',
  },
  {
    title: t('multi-menu.watermarks-title'),
    description: t('multi-menu.watermarks-description'),
    color: '#D1A3FF',
    // eslint-disable-next-line global-require
    icon: require('@/assets/icons/multi-menu/watermarks.svg'),
    service: 'watermarks',
  },
]);

// eslint-disable-next-line max-len
const computedMenuList = computed(() => menuList.value.filter((menuItem: IMultiMenuItem) => servicesList.value.find((serviceItem: string) => menuItem.service === serviceItem)));
// eslint-disable-next-line max-len
const sectionIndex = computed(() => computedMenuList.value.findIndex((menuItem: IMultiMenuItem) => menuItem.service === currentService.value));

const changeServiceHandler = (service: TService): void => {
  menuOpened.value = false;
  currentService.value = service;
  // if (imageResult.value !== '') {
  sourceBgImage.value = '';
  imageForActions.value = '';
  imagePrev.value = '';
  imageResult.value = '';
  generateImageData.value.products = [];
  // }
};

return (_ctx: any,_cache: any) => {
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (computedMenuList.value[sectionIndex.value])
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(["multi-menu d-flex align-center", { 'multi-menu--opened': menuOpened.value, 'multi-menu--mobile': _unref(isMobile) }])
      }, [
        _createVNode(AiClearButton, {
          class: "multi-menu__button d-flex align-center",
          style: _normalizeStyle({
      'border-color': computedMenuList.value[sectionIndex.value].color,
      background: `rgb(from ${computedMenuList.value[sectionIndex.value].color} r g b / 0.1)`,
    }),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(servicesList).length > 1 ? menuOpened.value = !menuOpened.value : null))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: "multi-menu__button__text",
              style: _normalizeStyle({ color: computedMenuList.value[sectionIndex.value].color })
            }, _toDisplayString(computedMenuList.value[sectionIndex.value].title), 5)
          ]),
          _: 1
        }, 8, ["style"]),
        _createVNode(_component_v_spacer),
        (_unref(servicesList).length > 1)
          ? (_openBlock(), _createBlock(AiClearButton, {
              key: 0,
              onClick: _cache[1] || (_cache[1] = ($event: any) => (menuOpened.value = !menuOpened.value)),
              class: "all-services"
            }, {
              default: _withCtx(() => [
                (!_unref(isMobile))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(_ctx.$t('multi-menu.all-services')), 1)
                    ], 64))
                  : _createCommentVNode("", true),
                _createVNode(_component_inline_svg, {
                  src: require('@/assets/icons/multi-menu/all.svg'),
                  style: _normalizeStyle({ color: computedMenuList.value[sectionIndex.value].color })
                }, null, 8, ["src", "style"])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createVNode(_component_v_dialog, {
          "model-value": menuOpened.value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (menuOpened.value = false)),
          scrim: false,
          "content-class": { 'multi-menu__menu': true, 'multi-menu__menu--mobile': _unref(isMobile) },
          attach: ".app-template",
          absolute: ""
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", {
              class: _normalizeClass(["multi-menu__menu__list", { 'multi-menu__menu__list--mobile': _unref(isMobile) }])
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(computedMenuList.value, (item, index) => {
                return (_openBlock(), _createBlock(AiClearButton, {
                  key: index,
                  class: "multi-menu__menu__list__item",
                  onClick: ($event: any) => (changeServiceHandler(item.service))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                      _createVNode(_component_inline_svg, {
                        src: item.icon
                      }, null, 8, ["src"])
                    ]),
                    _createElementVNode("div", _hoisted_2, _toDisplayString(item.title), 1),
                    _createElementVNode("div", _hoisted_3, _toDisplayString(item.description), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"]))
              }), 128))
            ], 2)
          ]),
          _: 1
        }, 8, ["model-value", "content-class"])
      ], 2))
    : _createCommentVNode("", true)
}
}

})